import { Component, EventEmitter, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { TaiwanDiscountPreviewRow } from '../../../../../core/models/parking/taiwan-discount.model';
import { ApiTaiwanDiscountService } from '../../../../../core/services/api/parking/api-taiwan-discount.service';
import { MenuPermissionService } from '../../../../../core/services/menu-permission.service';
import { MapperParkingMasterDataService } from '../../../../../core/mappers/system-settings/mapper-parking-master-data.service';

@Component({
  selector: 'app-modal-taiwan-discount-preview',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-taiwan-discount-preview.component.html',
  styleUrl: './modal-taiwan-discount-preview.component.css',
})
export class ModalTaiwanDiscountPreviewComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() imported = new EventEmitter<void>();

  rows: TaiwanDiscountPreviewRow[] = [];
  isLoading = signal(false);
  savingUuid = signal<string | null>(null);
  currentPage = 1;
  totalPages = 1;

  private readonly api = inject(ApiTaiwanDiscountService);
  private readonly toast = inject(ToastService);
  private readonly cookieService = inject(CookieService);
  private readonly router = inject(Router);
  private readonly permissionService = inject(MenuPermissionService);
  private readonly mapper = inject(MapperParkingMasterDataService);

  ngOnInit(): void { this.loadPreview(); }

  onClose(): void { this.close.emit(); }

  loadPreview(page = 1): void {
    this.isLoading.set(true);
    this.currentPage = page;
    this.api.previewTaiwanDiscountFromApi(page, 10).subscribe({
      next: (res) => {
        const raw = res as Record<string, unknown>;
        const list = (raw['data'] ?? raw['Data'] ?? []) as Record<string, unknown>[];
        this.rows = list.map((r) => ({
          uuid: String(r['uuid'] ?? r['Uuid'] ?? ''),
          name: String(r['name'] ?? r['Name'] ?? ''),
          isOnline: !!(r['isOnline'] ?? r['IsOnline']),
          carCategory: Number(r['carCategory'] ?? r['CarCategory'] ?? 0),
          type: Number(r['type'] ?? r['Type'] ?? 0),
          taiwanCreatedAt: (r['taiwanCreatedAt'] ?? r['TaiwanCreatedAt'] ?? null) as string | null,
          taiwanUpdatedAt: (r['taiwanUpdatedAt'] ?? r['TaiwanUpdatedAt'] ?? null) as string | null,
          existsInDb: !!(r['existsInDb'] ?? r['ExistsInDb']),
          localId: (r['localId'] ?? r['LocalId'] ?? null) as number | null,
        }));
        this.totalPages = Number(raw['totalPages'] ?? raw['TotalPages'] ?? 1);
        this.isLoading.set(false);
      },
      error: () => { this.rows = []; this.isLoading.set(false); this.toast.error('โหลด preview ไม่สำเร็จ'); },
    });
  }

  importRow(row: TaiwanDiscountPreviewRow): void {
    const userId = Number(this.cookieService.get('user_id') || 0);
    const menuId = this.permissionService.getMenuId(this.router.url) || 0;
    if (!userId || !menuId) { this.toast.error('ไม่พบข้อมูลสิทธิ์'); return; }

    const payload = {
      userId,
      menuId,
      uuid: row.uuid,
      name: row.name,
      isOnline: row.isOnline,
      carCategory: row.carCategory,
      type: row.type,
      taiwanCreatedAt: row.taiwanCreatedAt,
      taiwanUpdatedAt: row.taiwanUpdatedAt,
    };

    this.savingUuid.set(row.uuid);
    const request$ = row.existsInDb
      ? this.api.updateTaiwanDiscountFromPreview(payload)
      : this.api.insertTaiwanDiscountFromPreview(payload);

    request$.subscribe({
      next: (res) => {
        const mapped = this.mapper.mapActionResponse(res);
        this.savingUuid.set(null);
        if (!mapped.isSuccess) {
          this.toast.error(mapped.message || 'บันทึกไม่สำเร็จ');
          return;
        }
        this.toast.success(row.existsInDb ? 'อัปเดตเรียบร้อย' : 'นำเข้าเรียบร้อย');
        row.existsInDb = true;
        this.imported.emit();
      },
      error: (err) => {
        this.savingUuid.set(null);
        this.toast.error(err?.error?.message || 'เกิดข้อผิดพลาด');
      },
    });
  }
}
